import React, { Component } from "react";
import { Mutation } from "react-apollo";
import { connect } from "react-redux";
import { Box } from "reflexbox";
import { toast } from "react-toastify";
import { Panel, PanelType } from "office-ui-fabric-react/lib/Panel";

import {
  createOrder,
  updateOrderById,
  ordersByShipmentId
} from "../../queries/orders";

import { deselectOrder } from "../../actions/select_actions";
import { dismissForm } from "../../actions/ui_actions";

import Input from "../../common/Dropdowns/_Input";
import BuyerSelect from "../../common/Dropdowns/_BuyerSelect";
import LoadAtSelect from "../../common/Dropdowns/_LoadAtSelect";
import SellerSelect from "../../common/Dropdowns/_SellerSelect";
import PackingTypeSelect from "../../common/Dropdowns/_PackingTypeSelect";
import CountrySelect from "../../common/Dropdowns/_CountrySelect";
import DateSelect from "../../common/Dropdowns/_DateSelect";
import ShipperSelect from "../../common/Dropdowns/_ShipperSelect";
import CargoTypeSelect from "../../common/Dropdowns/_CargoTypeSelect";

import {
  PrimaryButton,
  CommandBarButton
} from "office-ui-fabric-react/lib/Button";
import { Formik, Form } from "formik";

class OrderForm extends Component {

  dismissModal = () => {
    this.props.deselectOrder();
    this.props.dismissForm();
  };

  getPackingType = () => {
    if (this.props.shipment.cargoTypeId === 1) {
      return 1; // flowerboxes
    } else if (this.props.shipment.cargoTypeId === 2) {
      return 4; // cc trolleys
    }
    return null;
  };

  render() {
    const {
      pickupDate,
      shipperId,
      sellerId,
      loadAtId,
      packingCode,
      buyerId,
      cargoTypeId,
      loadingOrder,
      boxes,
      boxesControle,
      brutto,
      awb,
      packingId,
      countryId,
      about
    } = this.props.order;

    const { addOrEdit } = this.props;

    return (
      <div>
        <Panel
          className="form-panel"
          isBlocking={true}
          isOpen={this.props.visible}
          onDismiss={this.dismissModal}
          isLightDismiss={true}
          type={PanelType.custom}
          customWidth={500}
          headerText="Order form"
          forceFocusInsideTram={false}
        >
          <Mutation
            mutation={
              this.props.addOrEdit === "edit" ? updateOrderById : createOrder
            }
          // refetchQueries={['ordersByShipmentId']}
          >
            {(mutate, { data }) => (
              <Formik
                onSubmit={values => {
                  const id = this.props.order.id;
                  const shipmentId = this.props.shipment.id;
                  const {
                    pickupDate,
                    shipperId,
                    sellerId,
                    loadAtId,
                    packingCode,
                    buyerId,
                    cargoTypeId,
                    loadingOrder,
                    boxes,
                    boxesControle,
                    brutto,
                    awb,
                    packingId,
                    countryId,
                    about
                  } = values;
                  mutate({
                    refetchQueries: [
                      {
                        query: ordersByShipmentId,
                        variables: { id: this.props.shipment.id }
                      }
                    ],
                    variables: {
                      id: id,
                      shipmentId: shipmentId,
                      pickupDate: pickupDate,
                      shipperId: shipperId,
                      sellerId: sellerId,
                      loadAtId: loadAtId,
                      packingCode: packingCode,
                      buyerId: buyerId,
                      cargoTypeId: cargoTypeId,
                      loadingOrder: loadingOrder,
                      boxes: parseInt(boxes, 10),
                      boxesControle: boxesControle,
                      brutto: parseInt(brutto, 10),
                      packingId: packingId,
                      countryId: countryId,
                      about: about
                    }
                  })
                    .then(response => {
                      this.props.deselectOrder();
                      this.dismissModal();
                      toast.success(`Success ! ${response}`);
                    })
                    .catch(err => {
                      toast.error(`${err}`);
                    });
                }}
                initialValues={{
                  pickupDate: addOrEdit === "edit" ? pickupDate : new Date(),
                  shipperId:
                    addOrEdit === "edit"
                      ? shipperId
                      : this.props.shipment.relationId,
                  sellerId: sellerId,
                  loadAtId: loadAtId,
                  packingCode: packingCode,
                  buyerId: buyerId,
                  cargoTypeId:
                    addOrEdit === "edit"
                      ? cargoTypeId
                      : this.props.shipment.cargoTypeId,
                  loadingOrder: loadingOrder,
                  boxes: boxes,
                  boxesControle: boxesControle,
                  brutto: brutto,
                  packingId:
                    addOrEdit === "edit" ? packingId : this.getPackingType(),
                  countryId: addOrEdit === "edit" ? countryId : 150, // Netherlands (id 150) as default
                  about: about
                }}
                validate={(values, props) => {
                  const errors = {};
                  if (!values.pickupDate) {
                    errors.pickupDate = "Required";
                  }
                  if (!values.shipperId) {
                    errors.shipperId = "Required";
                  }
                  if (!values.sellerId) {
                    errors.sellerId = "Required";
                  }
                  if (!values.packingCode) {
                    errors.packingCode = "Required";
                  }
                  if (!values.cargoTypeId) {
                    errors.cargoTypeId = "Required";
                  }
                  if (!values.packingId) {
                    errors.packingId = "Required";
                  }
                  if (!values.countryId) {
                    errors.countryId = "Required";
                  }
                  return errors;
                }}
                render={props => (
                  <Form>
                    <Box pt={1}>
                      <Box flex justify="space-between">
                        <Box w={0.5}>
                          <DateSelect
                            name="pickupDate"
                            label="Loading date"
                            value={props.values.pickupDate}
                            onChange={props.setFieldValue}
                            onBlur={props.setFieldTouched}
                            error={props.errors.pickupDate}
                            touched={props.touched.pickupDate}
                          />
                        </Box>
                        <Box auto pl={1}>
                          <ShipperSelect
                            name="shipperId"
                            label="Shipper"
                            value={props.values.shipperId}
                            onChange={props.setFieldValue}
                            onBlur={props.setFieldTouched}
                            error={props.errors.shipperId}
                            touched={props.touched.shipperId}
                          />
                        </Box>
                      </Box>
                      <Box flex justify="space-between">
                        <Box w={0.5}>
                          <SellerSelect
                            name="sellerId"
                            label="Seller"
                            value={props.values.sellerId}
                            onChange={props.setFieldValue}
                            onBlur={props.setFieldTouched}
                            error={props.errors.sellerId}
                            touched={props.touched.sellerId}
                          />
                        </Box>
                        <Box auto pl={1}>
                          <LoadAtSelect
                            name="loadAtId"
                            label="Loading location"
                            value={props.values.loadAtId}
                            onChange={props.setFieldValue}
                            onBlur={props.setFieldTouched}
                            error={props.errors.loadAtId}
                            touched={props.touched.loadAtId}
                          />
                        </Box>
                      </Box>
                      <Box flex justify="space-between">
                        <Box w={0.5}>
                          <Input
                            name="packingCode"
                            label="Packing Code"
                            value={props.values.packingCode}
                            onChange={props.setFieldValue}
                            onBlur={props.setFieldTouched}
                            error={props.errors.packingCode}
                            touched={props.touched.packingCode}
                          />
                        </Box>
                        <Box auto pl={1}>
                          <BuyerSelect
                            name="buyerId"
                            label="Buyer"
                            value={props.values.buyerId}
                            onChange={props.setFieldValue}
                            onBlur={props.setFieldTouched}
                            error={props.errors.buyerId}
                            touched={props.touched.buyerId}
                          />
                        </Box>
                      </Box>

                      <Box flex justify="space-between">
                        <Box auto>
                          <Input
                            name="boxes"
                            label="Boxes"
                            value={props.values.boxes}
                            onChange={props.setFieldValue}
                            onBlur={props.setFieldTouched}
                            error={props.errors.boxes}
                            touched={props.touched.boxes}
                          />
                        </Box>
                        <Box auto pl={1}>
                          <Input
                            name="boxesControle"
                            label="Box Control"
                            value={props.values.boxesControle}
                            onChange={props.setFieldValue}
                            onBlur={props.setFieldTouched}
                            error={props.errors.boxesControle}
                            touched={props.touched.boxesControle}
                          />
                        </Box>
                        <Box auto pl={1}>
                          <Input
                            name="brutto"
                            label="Brutto"
                            value={props.values.brutto}
                            onChange={props.setFieldValue}
                            onBlur={props.setFieldTouched}
                            error={props.errors.brutto}
                            touched={props.touched.brutto}
                          />
                        </Box>
                        <Box auto pl={1}>
                          <Input
                            name="loadingOrder"
                            label="Loading Order"
                            value={props.values.loadingOrder}
                            onChange={props.setFieldValue}
                            onBlur={props.setFieldTouched}
                            error={props.errors.loadingOrder}
                            touched={props.touched.loadingOrder}
                          />
                        </Box>
                      </Box>
                      <Box>
                        <CargoTypeSelect
                          name="cargoTypeId"
                          label="Cargo type"
                          value={props.values.cargoTypeId}
                          onChange={props.setFieldValue}
                          onBlur={props.setFieldTouched}
                          error={props.errors.cargoTypeId}
                          touched={props.touched.cargoTypeId}
                        />
                      </Box>
                      <Box>
                        <PackingTypeSelect
                          name="packingId"
                          label="Packing type"
                          value={props.values.packingId}
                          onChange={props.setFieldValue}
                          onBlur={props.setFieldTouched}
                          error={props.errors.packingId}
                          touched={props.touched.packingId}
                        />
                      </Box>
                      <Box>
                        <CountrySelect
                          name="countryId"
                          label="Country of origin"
                          value={props.values.countryId}
                          onChange={props.setFieldValue}
                          onBlur={props.setFieldTouched}
                          error={props.errors.countryId}
                          touched={props.touched.countryId}
                        />
                      </Box>
                      <Box>
                        <Input
                          name="about"
                          label="Additional info"
                          value={props.values.about}
                          onChange={props.setFieldValue}
                          onBlur={props.setFieldTouched}
                          error={props.errors.about}
                          touched={props.touched.about}
                        />
                      </Box>
                    </Box>
                    <Box mt={1}>
                      <PrimaryButton
                        type="submit"
                        text="Submit"
                        disable={props.isSubmitting}
                      />
                    </Box>
                  </Form>
                )}
              />
            )}
          </Mutation>
        </Panel>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    // order: state.selected.order ? state.selected.order : "",
    order: state.selected.order,
    shipment: state.selected.shipment
  };
};

export default connect(mapStateToProps, {
  deselectOrder: deselectOrder,
  dismissForm: dismissForm
})(OrderForm);



// WEBPACK FOOTER //
// ./src/common/Forms/_OrderForm.js